var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g, _defs, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _g2, _defs2, _path69, _path70, _path71, _path72;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 448 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ":root>svg{display:none}:root>svg:target{display:block}")), /*#__PURE__*/React.createElement("svg", _extends({
    id: "user",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C12.7614 12.5 15 10.2614 15 7.5C15 4.73858 12.7614 2.5 10 2.5C7.23858 2.5 5 4.73858 5 7.5C5 10.2614 7.23858 12.5 10 12.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42188 16.8747C3.18979 15.5444 4.2944 14.4396 5.62465 13.6715C6.9549 12.9034 8.46392 12.499 10 12.499C11.5361 12.499 13.0451 12.9034 14.3753 13.6715C15.7056 14.4396 16.8102 15.5444 17.5781 16.8747",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "v",
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.217391 0.207852C0.362319 0.0692836 0.533914 -4.57487e-07 0.732174 -4.48821e-07C0.930049 -4.40172e-07 1.10145 0.0692836 1.24638 0.207852L5.49275 4.2679L9.75362 0.193995C9.88889 0.064665 10.058 -4.11774e-08 10.2609 -3.23084e-08C10.4638 -2.34394e-08 10.6377 0.0692841 10.7826 0.207852C10.9275 0.34642 11 0.510485 11 0.700046C11 0.889238 10.9275 1.05312 10.7826 1.19169L5.89855 5.84758C5.84058 5.903 5.77778 5.94236 5.71014 5.96564C5.64251 5.98855 5.57005 6 5.49275 6C5.41546 6 5.34299 5.98855 5.27536 5.96564C5.20773 5.94236 5.14493 5.903 5.08696 5.84758L0.202899 1.17783C0.0676336 1.0485 -3.88698e-08 0.889237 -3.06e-08 0.700046C-2.2314e-08 0.510485 0.072464 0.34642 0.217391 0.207852Z",
    fill: "#121212"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "burger-open",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H20C20.55 18 21 17.55 21 17C21 16.45 20.55 16 20 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18ZM4 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13ZM3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7Z",
    fill: "#121212"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "burger-close",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 5.71022C18.2075 5.61752 18.0976 5.54397 17.9766 5.49379C17.8556 5.44361 17.7259 5.41778 17.595 5.41778C17.464 5.41778 17.3343 5.44361 17.2134 5.49379C17.0924 5.54397 16.9825 5.61752 16.89 5.71022L12 10.5902L7.10998 5.70022C7.0174 5.60764 6.90749 5.5342 6.78652 5.4841C6.66556 5.43399 6.53591 5.4082 6.40498 5.4082C6.27405 5.4082 6.1444 5.43399 6.02344 5.4841C5.90247 5.5342 5.79256 5.60764 5.69998 5.70022C5.6074 5.79281 5.53396 5.90272 5.48385 6.02368C5.43375 6.14464 5.40796 6.27429 5.40796 6.40522C5.40796 6.53615 5.43375 6.6658 5.48385 6.78677C5.53396 6.90773 5.6074 7.01764 5.69998 7.11022L10.59 12.0002L5.69998 16.8902C5.6074 16.9828 5.53396 17.0927 5.48385 17.2137C5.43375 17.3346 5.40796 17.4643 5.40796 17.5952C5.40796 17.7262 5.43375 17.8558 5.48385 17.9768C5.53396 18.0977 5.6074 18.2076 5.69998 18.3002C5.79256 18.3928 5.90247 18.4662 6.02344 18.5163C6.1444 18.5665 6.27405 18.5922 6.40498 18.5922C6.53591 18.5922 6.66556 18.5665 6.78652 18.5163C6.90749 18.4662 7.0174 18.3928 7.10998 18.3002L12 13.4102L16.89 18.3002C16.9826 18.3928 17.0925 18.4662 17.2134 18.5163C17.3344 18.5665 17.464 18.5922 17.595 18.5922C17.7259 18.5922 17.8556 18.5665 17.9765 18.5163C18.0975 18.4662 18.2074 18.3928 18.3 18.3002C18.3926 18.2076 18.466 18.0977 18.5161 17.9768C18.5662 17.8558 18.592 17.7262 18.592 17.5952C18.592 17.4643 18.5662 17.3346 18.5161 17.2137C18.466 17.0927 18.3926 16.9828 18.3 16.8902L13.41 12.0002L18.3 7.11022C18.68 6.73022 18.68 6.09022 18.3 5.71022Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrSLider",
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3854 20.8592L1.25837 11.7592C1.15003 11.6509 1.07348 11.5336 1.0287 11.4072C0.983199 11.2808 0.960449 11.1454 0.960449 11.0009C0.960449 10.8565 0.983199 10.7211 1.0287 10.5947C1.07348 10.4683 1.15003 10.3509 1.25837 10.2426L10.3854 1.11549C10.6382 0.862717 10.9542 0.736328 11.3334 0.736328C11.7125 0.736328 12.0375 0.871745 12.3084 1.14258C12.5792 1.41341 12.7146 1.72938 12.7146 2.09049C12.7146 2.45161 12.5792 2.76758 12.3084 3.03841L4.34587 11.0009L12.3084 18.9634C12.5611 19.2162 12.6875 19.5275 12.6875 19.8972C12.6875 20.2677 12.5521 20.5884 12.2813 20.8592C12.0104 21.1301 11.6945 21.2655 11.3334 21.2655C10.9723 21.2655 10.6563 21.1301 10.3854 20.8592Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "star",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5152 4.73437L10.0185 4.12096L8.00833 0.295904C7.95343 0.191176 7.8631 0.106396 7.75153 0.0548636C7.4717 -0.0747994 7.13166 0.0332531 6.99174 0.295904L4.9816 4.12096L0.484887 4.73437C0.360913 4.75099 0.247566 4.80585 0.160784 4.88896C0.0558699 4.99018 -0.00194268 5.12635 4.9848e-05 5.26755C0.00204238 5.40875 0.063677 5.54344 0.17141 5.64201L3.42484 8.61927L2.6562 12.8233C2.63818 12.9211 2.64971 13.0217 2.68948 13.1137C2.72926 13.2056 2.79569 13.2853 2.88125 13.3436C2.9668 13.4019 3.06805 13.4366 3.17353 13.4437C3.279 13.4507 3.38446 13.4299 3.47797 13.3836L7.50004 11.3987L11.5221 13.3836C11.6319 13.4384 11.7594 13.4567 11.8816 13.4367C12.1898 13.3869 12.397 13.1126 12.3439 12.8233L11.5752 8.61927L14.8287 5.64201C14.9172 5.56055 14.9757 5.45416 14.9934 5.3378C15.0412 5.04689 14.8251 4.77759 14.5152 4.73437Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "minus",
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0607 14.1387H7.18187C6.89724 14.1387 6.62426 14.0256 6.42299 13.8243C6.22172 13.623 6.10864 13.3501 6.10864 13.0654C6.10864 12.7808 6.22172 12.5078 6.42299 12.3065C6.62426 12.1053 6.89724 11.9922 7.18187 11.9922H20.0607C20.3453 11.9922 20.6183 12.1053 20.8196 12.3065C21.0208 12.5078 21.1339 12.7808 21.1339 13.0654C21.1339 13.3501 21.0208 13.623 20.8196 13.8243C20.6183 14.0256 20.3453 14.1387 20.0607 14.1387Z",
    fill: "#121212"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "fb",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.4453C20 4.92531 15.52 0.445312 10 0.445312C4.48 0.445312 0 4.92531 0 10.4453C0 15.2853 3.44 19.3153 8 20.2453V13.4453H6V10.4453H8V7.94531C8 6.01531 9.57 4.44531 11.5 4.44531H14V7.44531H12C11.45 7.44531 11 7.89531 11 8.44531V10.4453H14V13.4453H11V20.3953C16.05 19.8953 20 15.6353 20 10.4453Z",
    fill: "#413D3D"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "linkedin",
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2001 0.0449219C1.77575 0.0449219 1.36878 0.213493 1.06873 0.513551C0.768669 0.813609 0.600098 1.22058 0.600098 1.64492V19.2449C0.600098 19.6693 0.768669 20.0762 1.06873 20.3763C1.36878 20.6763 1.77575 20.8449 2.2001 20.8449H19.8001C20.2244 20.8449 20.6314 20.6763 20.9315 20.3763C21.2315 20.0762 21.4001 19.6693 21.4001 19.2449V1.64492C21.4001 1.22058 21.2315 0.813609 20.9315 0.513551C20.6314 0.213493 20.2244 0.0449219 19.8001 0.0449219H2.2001ZM3.8801 8.04492H6.9201V17.6449H3.8801V8.04492ZM7.1201 4.85292C7.1201 5.30909 6.93888 5.74658 6.61632 6.06914C6.29376 6.39171 5.85627 6.57292 5.4001 6.57292C4.94392 6.57292 4.50644 6.39171 4.18387 6.06914C3.86131 5.74658 3.6801 5.30909 3.6801 4.85292C3.6801 4.39675 3.86131 3.95926 4.18387 3.6367C4.50644 3.31414 4.94392 3.13292 5.4001 3.13292C5.85627 3.13292 6.29376 3.31414 6.61632 3.6367C6.93888 3.95926 7.1201 4.39675 7.1201 4.85292ZM18.2001 11.8161C18.2001 8.92812 16.3329 7.80492 14.4785 7.80492C13.8724 7.77548 13.269 7.90278 12.7265 8.17452C12.3153 8.38252 11.8849 8.85292 11.5521 9.67532H11.4673V8.04492H8.6001V17.6529H11.6497V12.5409C11.6065 12.0177 11.7729 11.3409 12.1153 10.9393C12.4593 10.5361 12.9473 10.4401 13.3201 10.3921H13.4369C14.4065 10.3921 15.1265 10.9921 15.1265 12.5041V17.6513H18.1761L18.2001 11.8161Z",
    fill: "#413D3D"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "arr-long",
    width: 104,
    height: 16,
    viewBox: "0 0 104 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.707 7.29289C104.098 7.68342 104.098 8.31658 103.707 8.70711L97.3431 15.0711C96.9526 15.4616 96.3195 15.4616 95.9289 15.0711C95.5384 14.6805 95.5384 14.0474 95.9289 13.6569L101.586 8L95.9289 2.34315C95.5384 1.95262 95.5384 1.31946 95.9289 0.928932C96.3195 0.538408 96.9526 0.538408 97.3431 0.928932L103.707 7.29289ZM0 7L103 7V9L0 9L0 7Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "arr-short",
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7071 7.29289C30.0976 7.68342 30.0976 8.31658 29.7071 8.70711L23.3431 15.0711C22.9526 15.4616 22.3195 15.4616 21.9289 15.0711C21.5384 14.6805 21.5384 14.0474 21.9289 13.6569L27.5858 8L21.9289 2.34315C21.5384 1.95262 21.5384 1.31946 21.9289 0.928932C22.3195 0.538408 22.9526 0.538408 23.3431 0.928932L29.7071 7.29289ZM0 7L29 7V9L0 9L0 7Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "userAc",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5C15.3137 15.5 18 12.8137 18 9.5C18 6.18629 15.3137 3.5 12 3.5C8.68629 3.5 6 6.18629 6 9.5C6 12.8137 8.68629 15.5 12 15.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90625 20.7508C3.82775 19.1544 5.15328 17.8287 6.74958 16.907C8.34588 15.9853 10.1567 15.5 12 15.5C13.8433 15.5 15.6541 15.9853 17.2504 16.907C18.8467 17.8287 20.1722 19.1544 21.0938 20.7508",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "bell",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26879 10.2501C5.26754 9.36096 5.44222 8.48035 5.78275 7.65901C6.12329 6.83766 6.62296 6.0918 7.25299 5.46438C7.88302 4.83697 8.63095 4.34041 9.45371 4.00329C10.2765 3.66617 11.1578 3.49516 12.0469 3.5001C15.7594 3.52823 18.7313 6.6126 18.7313 10.3345V11.0001C18.7313 14.3564 19.4344 16.3064 20.0532 17.3751C20.1189 17.4889 20.1535 17.618 20.1537 17.7494C20.1538 17.8809 20.1193 18.01 20.0538 18.124C19.9883 18.2379 19.894 18.3326 19.7804 18.3986C19.6667 18.4647 19.5377 18.4996 19.4063 18.5001H4.59379C4.46237 18.4996 4.33337 18.4647 4.21972 18.3986C4.10607 18.3326 4.01177 18.2379 3.94626 18.124C3.88074 18.01 3.84632 17.8809 3.84644 17.7494C3.84655 17.618 3.8812 17.4889 3.94692 17.3751C4.56567 16.3064 5.26879 14.3564 5.26879 11.0001V10.2501Z",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.5V19.25C9 20.0456 9.31607 20.8087 9.87868 21.3713C10.4413 21.9339 11.2044 22.25 12 22.25C12.7956 22.25 13.5587 21.9339 14.1213 21.3713C14.6839 20.8087 15 20.0456 15 19.25V18.5",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "v-ac",
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 1.25L5 4.375L1.875 1.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "pencil",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24219 16.874H3.75C3.58424 16.874 3.42527 16.8081 3.30806 16.6909C3.19085 16.5737 3.125 16.4147 3.125 16.249V12.7568C3.12472 12.6756 3.14044 12.5952 3.17128 12.5201C3.20211 12.445 3.24745 12.3768 3.30469 12.3193L12.6797 2.94427C12.7378 2.88521 12.8072 2.83832 12.8836 2.80631C12.9601 2.7743 13.0421 2.75781 13.125 2.75781C13.2079 2.75781 13.2899 2.7743 13.3664 2.80631C13.4428 2.83832 13.5122 2.88521 13.5703 2.94427L17.0547 6.42864C17.1137 6.4868 17.1606 6.55612 17.1927 6.63257C17.2247 6.70902 17.2411 6.79107 17.2411 6.87395C17.2411 6.95684 17.2247 7.03889 17.1927 7.11534C17.1606 7.19179 17.1137 7.26111 17.0547 7.31927L7.67969 16.6943C7.62216 16.7515 7.55391 16.7968 7.47884 16.8277C7.40376 16.8585 7.32335 16.8742 7.24219 16.874Z",
    stroke: "#FF5368",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 5L15 9.375",
    stroke: "#FF5368",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 7.1875L5.3125 14.6875",
    stroke: "#FF5368",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46094 16.8359L3.16406 12.5391",
    stroke: "#FF5368",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "light",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11 29H21",
    stroke: "#8D48E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83761 20.8759C8.6471 19.9502 7.68288 18.7657 7.01801 17.4121C6.35313 16.0585 6.00504 14.5714 6.00011 13.0634C5.97511 7.63836 10.3376 3.12586 15.7626 3.00086C17.8622 2.95108 19.9242 3.56361 21.6561 4.75156C23.388 5.93952 24.7019 7.64259 25.4115 9.61925C26.1211 11.5959 26.1904 13.7458 25.6094 15.764C25.0285 17.7823 23.827 19.5664 22.1751 20.8634C21.8102 21.1454 21.5146 21.5072 21.311 21.921C21.1073 22.3348 21.001 22.7897 21.0001 23.2509V24.0009C21.0001 24.2661 20.8948 24.5204 20.7072 24.708C20.5197 24.8955 20.2653 25.0009 20.0001 25.0009H12.0001C11.7349 25.0009 11.4805 24.8955 11.293 24.708C11.1055 24.5204 11.0001 24.2661 11.0001 24.0009V23.2509C10.997 22.7931 10.8909 22.342 10.6896 21.9308C10.4884 21.5197 10.1972 21.1591 9.83761 20.8759Z",
    stroke: "#8D48E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0125 7.09961C18.2347 7.3068 19.3624 7.88824 20.2401 8.76369C21.1178 9.63913 21.7021 10.7654 21.9125 11.9871",
    stroke: "#8D48E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "big-pencil",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 26.9999H6.50001C6.23479 26.9999 5.98044 26.8945 5.7929 26.707C5.60536 26.5195 5.50001 26.2651 5.50001 25.9999V20.4124C5.49955 20.2825 5.52471 20.1539 5.57404 20.0338C5.62338 19.9136 5.69591 19.8044 5.78751 19.7124L20.7875 4.71239C20.8806 4.61791 20.9915 4.54287 21.1138 4.49165C21.2361 4.44044 21.3674 4.41406 21.5 4.41406C21.6326 4.41406 21.7639 4.44044 21.8862 4.49165C22.0085 4.54287 22.1195 4.61791 22.2125 4.71239L27.7875 10.2874C27.882 10.3804 27.957 10.4914 28.0082 10.6137C28.0595 10.736 28.0858 10.8673 28.0858 10.9999C28.0858 11.1325 28.0595 11.2638 28.0082 11.3861C27.957 11.5084 27.882 11.6193 27.7875 11.7124L12.5 26.9999Z",
    stroke: "#FF5368",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8L24.5 15",
    stroke: "#FF5368",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 27H12.5L5.5625 20.0625",
    stroke: "#FF5368",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.5L9 23.5",
    stroke: "#FF5368",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "close",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.4008L7.09999 18.3008C6.91665 18.4841 6.68332 18.5758 6.39999 18.5758C6.11665 18.5758 5.88332 18.4841 5.69999 18.3008C5.51665 18.1174 5.42499 17.8841 5.42499 17.6008C5.42499 17.3174 5.51665 17.0841 5.69999 16.9008L10.6 12.0008L5.69999 7.10078C5.51665 6.91745 5.42499 6.68411 5.42499 6.40078C5.42499 6.11745 5.51665 5.88411 5.69999 5.70078C5.88332 5.51745 6.11665 5.42578 6.39999 5.42578C6.68332 5.42578 6.91665 5.51745 7.09999 5.70078L12 10.6008L16.9 5.70078C17.0833 5.51745 17.3167 5.42578 17.6 5.42578C17.8833 5.42578 18.1167 5.51745 18.3 5.70078C18.4833 5.88411 18.575 6.11745 18.575 6.40078C18.575 6.68411 18.4833 6.91745 18.3 7.10078L13.4 12.0008L18.3 16.9008C18.4833 17.0841 18.575 17.3174 18.575 17.6008C18.575 17.8841 18.4833 18.1174 18.3 18.3008C18.1167 18.4841 17.8833 18.5758 17.6 18.5758C17.3167 18.5758 17.0833 18.4841 16.9 18.3008L12 13.4008Z",
    fill: "#121212"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "show-pass",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7351 11.4464C16.8093 11.5751 16.8294 11.728 16.7912 11.8716C16.753 12.0152 16.6596 12.1378 16.5312 12.2128C16.4465 12.2641 16.3491 12.2909 16.25 12.2901C16.1504 12.291 16.0523 12.2654 15.9659 12.216C15.8794 12.1666 15.8076 12.0951 15.7578 12.0089L14.464 9.77292C13.7049 10.2836 12.8695 10.6704 11.989 10.919L12.3969 13.2323C12.4215 13.3794 12.3874 13.5304 12.302 13.6526C12.2165 13.7749 12.0865 13.8588 11.9398 13.8862H11.8414C11.709 13.8866 11.5807 13.8403 11.4791 13.7554C11.3775 13.6705 11.3091 13.5525 11.2859 13.4221L10.8851 11.144C10.4266 11.2124 9.96364 11.2476 9.49998 11.2495C9.03418 11.2497 8.56894 11.2168 8.1078 11.151L7.70702 13.4292C7.68385 13.5595 7.61544 13.6775 7.51384 13.7624C7.41223 13.8473 7.28394 13.8936 7.15155 13.8932H7.05311C6.90647 13.8658 6.77644 13.7819 6.69097 13.6597C6.60551 13.5374 6.57144 13.3865 6.59608 13.2393L7.01092 10.919C6.12767 10.672 5.28971 10.2851 4.52889 9.77292L3.22811 12.0229C3.17786 12.1072 3.10693 12.1773 3.02203 12.2265C2.93713 12.2757 2.84107 12.3025 2.74295 12.3042C2.64438 12.3038 2.54763 12.2776 2.4624 12.2281C2.37716 12.1786 2.30643 12.1075 2.2573 12.0221C2.20816 11.9366 2.18235 11.8397 2.18243 11.7412C2.18252 11.6426 2.20851 11.5458 2.2578 11.4604L3.62889 9.08386C3.14977 8.67295 2.70962 8.21868 2.31405 7.72682C2.2673 7.66983 2.23236 7.60409 2.21128 7.53346C2.19019 7.46282 2.18338 7.38869 2.19123 7.3154C2.19908 7.2421 2.22145 7.1711 2.25702 7.10653C2.29259 7.04197 2.34066 6.98513 2.39842 6.93932C2.45498 6.89218 2.52035 6.85676 2.59073 6.8351C2.6611 6.81345 2.73508 6.80601 2.80836 6.81321C2.88163 6.8204 2.95275 6.8421 3.01757 6.87703C3.08239 6.91196 3.13961 6.95942 3.18592 7.01667C3.62605 7.56539 4.12867 8.06093 4.68358 8.49323H4.69061C6.06364 9.56428 7.75868 10.1392 9.49998 10.1245C11.5601 10.1245 13.1422 9.40026 14.3023 8.50026H14.3164C14.8713 8.06796 15.3739 7.57242 15.814 7.0237C15.8598 6.96594 15.9167 6.91787 15.9813 6.8823C16.0458 6.84673 16.1168 6.82436 16.1901 6.81651C16.2634 6.80866 16.3375 6.81547 16.4082 6.83656C16.4788 6.85764 16.5445 6.89258 16.6015 6.93932C16.6593 6.98513 16.7074 7.04197 16.7429 7.10653C16.7785 7.1711 16.8009 7.2421 16.8087 7.3154C16.8166 7.38869 16.8098 7.46282 16.7887 7.53346C16.7676 7.60409 16.7327 7.66983 16.6859 7.72682C16.2904 8.21868 15.8502 8.67295 15.3711 9.08386L16.7351 11.4464Z",
    fill: "#9A9A9A"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "fb-auth",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 15C27.5 8.1 21.9 2.5 15 2.5C8.1 2.5 2.5 8.1 2.5 15C2.5 21.05 6.8 26.0875 12.5 27.25V18.75H10V15H12.5V11.875C12.5 9.4625 14.4625 7.5 16.875 7.5H20V11.25H17.5C16.8125 11.25 16.25 11.8125 16.25 12.5V15H20V18.75H16.25V27.4375C22.5625 26.8125 27.5 21.4875 27.5 15Z",
    fill: "#0077FB"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "google",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_545_432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1664 14.2625C28.1664 13.1154 28.0733 12.2783 27.8718 11.4102H14.7725V16.5878H22.4615C22.3066 17.8745 21.4694 19.8123 19.6091 21.1144L19.5831 21.2877L23.7248 24.4963L24.0118 24.5249C26.6471 22.0911 28.1664 18.5101 28.1664 14.2625Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7725 27.9035C18.5395 27.9035 21.7019 26.6632 24.0118 24.524L19.6091 21.1135C18.431 21.9351 16.8498 22.5086 14.7725 22.5086C11.083 22.5086 7.95163 20.0749 6.83537 16.7109L6.67175 16.7248L2.3651 20.0578L2.30878 20.2144C4.60307 24.7719 9.31572 27.9035 14.7725 27.9035Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.83538 16.7113C6.54085 15.8432 6.37039 14.913 6.37039 13.9519C6.37039 12.9907 6.54085 12.0606 6.81988 11.1925L6.81208 11.0076L2.45146 7.62109L2.30879 7.68896C1.3632 9.58024 0.820618 11.7041 0.820618 13.9519C0.820618 16.1997 1.3632 18.3234 2.30879 20.2147L6.83538 16.7113Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7725 5.3947C17.3923 5.3947 19.1595 6.52635 20.1672 7.47205L24.1047 3.6275C21.6865 1.37969 18.5395 0 14.7725 0C9.31572 0 4.60307 3.1314 2.30878 7.68899L6.81988 11.1925C7.95163 7.82857 11.083 5.3947 14.7725 5.3947Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_545_432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.3588,
    height: 28,
    fill: "white",
    transform: "translate(0.820618)"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "hide-pass",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 18",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A9A9A",
    d: "M9.5,5.7c-1.9,0-3.4,1.5-3.4,3.4s1.5,3.4,3.4,3.4s3.4-1.5,3.4-3.4S11.4,5.7,9.5,5.7z M9.5,10.9 c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8C11.3,10.1,10.5,10.9,9.5,10.9z M18.7,8.7c-2.3-3.1-5.6-4.9-9.2-4.9 S2.6,5.5,0.3,8.7L0,9.1l0.3,0.5c2.3,3.1,5.6,4.9,9.2,4.9s6.9-1.8,9.2-4.9L19,9.1L18.7,8.7z M9.5,12.9c-2.9,0-5.6-1.4-7.5-3.8 c1.9-2.4,4.7-3.8,7.5-3.8s5.6,1.4,7.5,3.8C15.1,11.5,12.4,12.9,9.5,12.9z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "sett",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17.1875C15.0888 17.1875 17.1875 15.0888 17.1875 12.5C17.1875 9.91117 15.0888 7.8125 12.5 7.8125C9.91117 7.8125 7.8125 9.91117 7.8125 12.5C7.8125 15.0888 9.91117 17.1875 12.5 17.1875Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9395 6.35742C18.1868 6.58529 18.4212 6.81966 18.6426 7.06055L21.3086 7.44141C21.743 8.19581 22.0778 9.00331 22.3047 9.84375L20.6836 12.002C20.6836 12.002 20.7129 12.666 20.6836 12.998L22.3047 15.1562C22.0789 15.997 21.744 16.8047 21.3086 17.5586L18.6426 17.9395C18.6426 17.9395 18.1836 18.418 17.9395 18.6426L17.5586 21.3086C16.8042 21.743 15.9967 22.0778 15.1562 22.3047L12.998 20.6836C12.6667 20.7129 12.3333 20.7129 12.002 20.6836L9.84375 22.3047C9.00295 22.0789 8.19532 21.744 7.44141 21.3086L7.06055 18.6426C6.81966 18.4147 6.58529 18.1803 6.35742 17.9395L3.69141 17.5586C3.25701 16.8042 2.9222 15.9967 2.69531 15.1562L4.31641 12.998C4.31641 12.998 4.28711 12.334 4.31641 12.002L2.69531 9.84375C2.92114 9.00295 3.25602 8.19532 3.69141 7.44141L6.35742 7.06055C6.58529 6.81966 6.81966 6.58529 7.06055 6.35742L7.44141 3.69141C8.19581 3.25701 9.00331 2.9222 9.84375 2.69531L12.002 4.31641C12.3333 4.2871 12.6667 4.2871 12.998 4.31641L15.1562 2.69531C15.997 2.92114 16.8047 3.25602 17.5586 3.69141L17.9395 6.35742Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "sign-out",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9922 8.39844L21.0938 12.5L16.9922 16.6016",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1562 12.5H21.0938",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1562 21.0938H4.6875C4.4803 21.0938 4.28159 21.0114 4.13507 20.8649C3.98856 20.7184 3.90625 20.5197 3.90625 20.3125V4.6875C3.90625 4.4803 3.98856 4.28159 4.13507 4.13507C4.28159 3.98856 4.4803 3.90625 4.6875 3.90625H10.1562",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "dashboard",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 13.125V4.375C1.875 4.04348 2.0067 3.72554 2.24112 3.49112C2.47554 3.2567 2.79348 3.125 3.125 3.125H16.875C17.2065 3.125 17.5245 3.2567 17.7589 3.49112C17.9933 3.72554 18.125 4.04348 18.125 4.375V13.125C18.125 13.2908 18.0592 13.4497 17.9419 13.5669C17.8247 13.6842 17.6658 13.75 17.5 13.75C17.3342 13.75 17.1753 13.6842 17.0581 13.5669C16.9408 13.4497 16.875 13.2908 16.875 13.125V4.375H3.125V13.125C3.125 13.2908 3.05915 13.4497 2.94194 13.5669C2.82473 13.6842 2.66576 13.75 2.5 13.75C2.33424 13.75 2.17527 13.6842 2.05806 13.5669C1.94085 13.4497 1.875 13.2908 1.875 13.125ZM19.375 15.625C19.375 15.7908 19.3092 15.9497 19.1919 16.0669C19.0747 16.1842 18.9158 16.25 18.75 16.25H1.25C1.08424 16.25 0.925268 16.1842 0.808058 16.0669C0.690848 15.9497 0.625 15.7908 0.625 15.625C0.625 15.4592 0.690848 15.3003 0.808058 15.1831C0.925268 15.0658 1.08424 15 1.25 15H8.75V13.125C8.75 12.9592 8.81585 12.8003 8.93306 12.6831C9.05027 12.5658 9.20924 12.5 9.375 12.5H14.375C14.5408 12.5 14.6997 12.5658 14.8169 12.6831C14.9342 12.8003 15 12.9592 15 13.125V15H18.75C18.9158 15 19.0747 15.0658 19.1919 15.1831C19.3092 15.3003 19.375 15.4592 19.375 15.625ZM10 15H13.75V13.75H10V15Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "mycv",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6922 6.43281L12.3172 2.05781C12.2591 1.99979 12.1902 1.95378 12.1143 1.92241C12.0384 1.89105 11.9571 1.87494 11.875 1.875H4.375C4.04348 1.875 3.72554 2.0067 3.49112 2.24112C3.2567 2.47554 3.125 2.79348 3.125 3.125V16.875C3.125 17.2065 3.2567 17.5245 3.49112 17.7589C3.72554 17.9933 4.04348 18.125 4.375 18.125H15.625C15.9565 18.125 16.2745 17.9933 16.5089 17.7589C16.7433 17.5245 16.875 17.2065 16.875 16.875V6.875C16.8751 6.7929 16.859 6.71159 16.8276 6.63572C16.7962 6.55985 16.7502 6.4909 16.6922 6.43281ZM12.5 4.00859L14.7414 6.25H12.5V4.00859ZM15.625 16.875H4.375V3.125H11.25V6.875C11.25 7.04076 11.3158 7.19973 11.4331 7.31694C11.5503 7.43415 11.7092 7.5 11.875 7.5H15.625V16.875Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "mycovers",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6922 5.18281L13.5672 2.05781C13.5091 1.99979 13.4402 1.95378 13.3643 1.92241C13.2884 1.89105 13.2071 1.87494 13.125 1.875H6.875C6.54348 1.875 6.22554 2.0067 5.99112 2.24112C5.7567 2.47554 5.625 2.79348 5.625 3.125V4.375H4.375C4.04348 4.375 3.72554 4.5067 3.49112 4.74112C3.2567 4.97554 3.125 5.29348 3.125 5.625V16.875C3.125 17.2065 3.2567 17.5245 3.49112 17.7589C3.72554 17.9933 4.04348 18.125 4.375 18.125H13.125C13.4565 18.125 13.7745 17.9933 14.0089 17.7589C14.2433 17.5245 14.375 17.2065 14.375 16.875V15.625H15.625C15.9565 15.625 16.2745 15.4933 16.5089 15.2589C16.7433 15.0245 16.875 14.7065 16.875 14.375V5.625C16.8751 5.5429 16.859 5.46159 16.8276 5.38572C16.7962 5.30985 16.7502 5.2409 16.6922 5.18281ZM13.125 16.875H4.375V5.625H10.3664L13.125 8.38359V14.9875C13.125 14.9922 13.125 14.9961 13.125 15C13.125 15.0039 13.125 15.0078 13.125 15.0125V16.875ZM15.625 14.375H14.375V8.125C14.3751 8.0429 14.359 7.96159 14.3276 7.88572C14.2962 7.80985 14.2502 7.7409 14.1922 7.68281L11.0672 4.55781C11.0091 4.49979 10.9402 4.45378 10.8643 4.42241C10.7884 4.39105 10.7071 4.37494 10.625 4.375H6.875V3.125H12.8664L15.625 5.88359V14.375ZM11.25 11.875C11.25 12.0408 11.1842 12.1997 11.0669 12.3169C10.9497 12.4342 10.7908 12.5 10.625 12.5H6.875C6.70924 12.5 6.55027 12.4342 6.43306 12.3169C6.31585 12.1997 6.25 12.0408 6.25 11.875C6.25 11.7092 6.31585 11.5503 6.43306 11.4331C6.55027 11.3158 6.70924 11.25 6.875 11.25H10.625C10.7908 11.25 10.9497 11.3158 11.0669 11.4331C11.1842 11.5503 11.25 11.7092 11.25 11.875ZM11.25 14.375C11.25 14.5408 11.1842 14.6997 11.0669 14.8169C10.9497 14.9342 10.7908 15 10.625 15H6.875C6.70924 15 6.55027 14.9342 6.43306 14.8169C6.31585 14.6997 6.25 14.5408 6.25 14.375C6.25 14.2092 6.31585 14.0503 6.43306 13.9331C6.55027 13.8158 6.70924 13.75 6.875 13.75H10.625C10.7908 13.75 10.9497 13.8158 11.0669 13.9331C11.1842 14.0503 11.25 14.2092 11.25 14.375Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "arr-back",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 12H3.75",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.25L3.75 12L10.5 18.75",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "preview",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28H7C6.73478 28 6.48043 27.8946 6.29289 27.7071C6.10536 27.5196 6 27.2652 6 27V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H19L26 11V27C26 27.2652 25.8946 27.5196 25.7071 27.7071C25.5196 27.8946 25.2652 28 25 28Z",
    stroke: "#FF5368",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4V11H26",
    stroke: "#FF5368",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9746 20.9746L19.9746 22.9746",
    stroke: "#FF5368",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22C17.433 22 19 20.433 19 18.5C19 16.567 17.433 15 15.5 15C13.567 15 12 16.567 12 18.5C12 20.433 13.567 22 15.5 22Z",
    stroke: "#FF5368",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "tooltip",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.875C7.39303 0.875 5.82214 1.35152 4.486 2.24431C3.14985 3.1371 2.10844 4.40605 1.49348 5.8907C0.87852 7.37535 0.717618 9.00901 1.03112 10.5851C1.34463 12.1612 2.11846 13.6089 3.25476 14.7452C4.39106 15.8815 5.8388 16.6554 7.4149 16.9689C8.99099 17.2824 10.6247 17.1215 12.1093 16.5065C13.594 15.8916 14.8629 14.8502 15.7557 13.514C16.6485 12.1779 17.125 10.607 17.125 9C17.1209 6.84638 16.2635 4.78216 14.7407 3.25932C13.2178 1.73648 11.1536 0.87913 9 0.875ZM8.84375 4.625C9.02917 4.625 9.21043 4.67998 9.3646 4.783C9.51877 4.88601 9.63893 5.03243 9.70989 5.20373C9.78085 5.37504 9.79941 5.56354 9.76324 5.7454C9.72707 5.92725 9.63778 6.0943 9.50667 6.22541C9.37555 6.35652 9.20851 6.44581 9.02665 6.48199C8.84479 6.51816 8.65629 6.49959 8.48499 6.42864C8.31368 6.35768 8.16726 6.23752 8.06425 6.08335C7.96124 5.92918 7.90625 5.74792 7.90625 5.5625C7.90625 5.31386 8.00503 5.0754 8.18084 4.89959C8.35666 4.72377 8.59511 4.625 8.84375 4.625ZM9.625 13.375H9C8.83424 13.375 8.67527 13.3092 8.55806 13.1919C8.44085 13.0747 8.375 12.9158 8.375 12.75V9C8.20924 9 8.05027 8.93415 7.93306 8.81694C7.81585 8.69973 7.75 8.54076 7.75 8.375C7.75 8.20924 7.81585 8.05027 7.93306 7.93306C8.05027 7.81585 8.20924 7.75 8.375 7.75H9C9.16576 7.75 9.32474 7.81585 9.44195 7.93306C9.55916 8.05027 9.625 8.20924 9.625 8.375V12.125C9.79076 12.125 9.94974 12.1908 10.0669 12.3081C10.1842 12.4253 10.25 12.5842 10.25 12.75C10.25 12.9158 10.1842 13.0747 10.0669 13.1919C9.94974 13.3092 9.79076 13.375 9.625 13.375Z",
    fill: "#9A9A9A"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "download",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 35H8.75C8.41848 35 8.10054 34.8683 7.86612 34.6339C7.6317 34.3995 7.5 34.0815 7.5 33.75V6.25C7.5 5.91848 7.6317 5.60054 7.86612 5.36612C8.10054 5.1317 8.41848 5 8.75 5H23.75L32.5 13.75V33.75C32.5 34.0815 32.3683 34.3995 32.1339 34.6339C31.8995 34.8683 31.5815 35 31.25 35Z",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 5V13.75H32.5",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 24.375L20 28.75L24.375 24.375",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.75V28.75",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "filetext",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 35H8.75C8.41848 35 8.10054 34.8683 7.86612 34.6339C7.6317 34.3995 7.5 34.0815 7.5 33.75V6.25C7.5 5.91848 7.6317 5.60054 7.86612 5.36612C8.10054 5.1317 8.41848 5 8.75 5H23.75L32.5 13.75V33.75C32.5 34.0815 32.3683 34.3995 32.1339 34.6339C31.8995 34.8683 31.5815 35 31.25 35Z",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 5V13.75H32.5",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.25H25",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26.25H25",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "money",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51562 31.4844C7.07813 30.0469 8.03125 27.0312 7.29688 25.2656C6.5625 23.5 3.75 21.9531 3.75 20C3.75 18.0469 6.53125 16.5625 7.29688 14.7344C8.0625 12.9063 7.07813 9.95312 8.51562 8.51562C9.95312 7.07813 12.9688 8.03125 14.7344 7.29688C16.5 6.5625 18.0469 3.75 20 3.75C21.9531 3.75 23.4375 6.53125 25.2656 7.29688C27.0937 8.0625 30.0469 7.07813 31.4844 8.51562C32.9219 9.95312 31.9688 12.9688 32.7031 14.7344C33.4375 16.5 36.25 18.0469 36.25 20C36.25 21.9531 33.4688 23.4375 32.7031 25.2656C31.9375 27.0937 32.9219 30.0469 31.4844 31.4844C30.0469 32.9219 27.0312 31.9688 25.2656 32.7031C23.5 33.4375 21.9531 36.25 20 36.25C18.0469 36.25 16.5625 33.4688 14.7344 32.7031C12.9063 31.9375 9.95312 32.9219 8.51562 31.4844Z",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M26.875 16.25L17.7031 25L13.125 20.625",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "coin",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C17.5228 15 22 12.9853 22 10.5C22 8.01472 17.5228 6 12 6C6.47715 6 2 8.01472 2 10.5C2 12.9853 6.47715 15 12 15Z",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5V15.5C2 17.9875 6.475 20 12 20C17.525 20 22 17.9875 22 15.5V10.5",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.625V19.625",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.0879C26.5625 12.5129 30 14.3254 30 16.5004C30 18.9879 25.525 21.0004 20 21.0004C17.55 21.0004 15.3 20.6004 13.5625 19.9504",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.9125V21.5C10 23.9875 14.475 26 20 26C25.525 26 30 23.9875 30 21.5V16.5",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.625V25.625",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.625V25.625",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "plus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z",
    fill: "red"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.695 15.117l6.531-6.344L15.5 6l-6.625 6.296 2.82 2.82zM10.27 16.52l-2.828-2.829-.446.446v2.828h2.829l.445-.445zm2.122.707l-1.415 1.414a1 1 0 0 1-.63.29H6.116c-.612.047-1.132-.306-1.085-.917v-4.4a1 1 0 0 1 .29-.63l2.12-2.121.018.017 6.909-6.578a1.6 1.6 0 0 1 2.263 0l3.292 3.338a1.6 1.6 0 0 1 0 2.263l-7.531 7.324z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8,19 L16,19 L16,13 L8,13 L8,19 Z M16,7 L20,7 L20,9 L4,9 L4,7 L8,7 L8,3 L16,3 L16,7 Z M14,7 L14,5 L10,5 L10,7 L14,7 Z M6,11 L18,11 L18,21 L6,21 L6,11 Z",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "download2",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9,6 L9,13 L7.20376823,13 L12,18.4814077 L16.7962318,13 L15,13 L15,6 L9,6 Z M7,11 L7,5 C7,4.44771525 7.44771525,4 8,4 L16,4 C16.5522847,4 17,4.44771525 17,5 L17,11 L19,11 C19.8591588,11 20.3183367,12.0119217 19.7525767,12.6585046 L12.7525767,20.6585046 C12.3541654,21.1138318 11.6458346,21.1138318 11.2474233,20.6585046 L4.24742331,12.6585046 C3.68166327,12.0119217 4.14084119,11 5,11 L7,11 Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "planet_lang",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4867 0.501068C11.0744 0.501068 10.6624 0.523231 10.2525 0.567413C9.87678 0.605791 9.50567 0.66873 9.13955 0.745101C9.0687 0.759925 8.99779 0.775564 8.92694 0.791922C6.76979 1.28306 4.80006 2.38598 3.25397 3.96843C3.1102 4.1158 2.96945 4.26754 2.83182 4.42359C-1.34462 9.21829 -0.843408 16.4908 3.95134 20.6673C8.54168 24.6657 15.4513 24.3996 19.7206 20.0601C19.8647 19.9128 20.0054 19.761 20.1428 19.605C21.9859 17.506 23.0016 14.8076 23 12.0143C23 5.65565 17.8453 0.50102 11.4867 0.501068ZM3.76554 4.54409C3.82618 4.48116 3.88912 4.4209 3.95091 4.35988C4.02229 4.28965 4.09329 4.21904 4.1662 4.15111C4.2303 4.09124 4.2963 4.03367 4.36193 3.97534C4.436 3.90971 4.50968 3.84409 4.58567 3.78077C4.65245 3.72435 4.72114 3.67024 4.78946 3.61574C4.86621 3.55434 4.94297 3.49293 5.02202 3.43383C5.09187 3.38126 5.16287 3.33021 5.23425 3.28032C5.31369 3.22352 5.39352 3.16519 5.4745 3.11223C5.54703 3.06311 5.62033 3.01552 5.69402 2.96831C5.77614 2.91574 5.85865 2.86393 5.94193 2.8148C6.01691 2.77004 6.09237 2.72601 6.16836 2.68278C6.25332 2.63443 6.33861 2.58722 6.42434 2.54117C6.5011 2.50025 6.57785 2.46019 6.6546 2.42105C6.74211 2.37691 6.83037 2.33432 6.91903 2.29248C6.99578 2.25603 7.07561 2.21957 7.15466 2.18503C7.24485 2.14665 7.33619 2.10827 7.42753 2.06989C7.50697 2.03727 7.58603 2.00542 7.66624 1.97472C7.75911 1.93941 7.85314 1.90641 7.94716 1.8734C8.02737 1.84539 8.10758 1.81737 8.18894 1.79089C8.2845 1.76019 8.38083 1.73179 8.47754 1.70377C8.55851 1.68036 8.63872 1.65618 8.72008 1.63431C8.75117 1.62625 8.78226 1.61973 8.81334 1.61167C7.67737 2.71469 6.83436 4.08361 6.36063 5.59449C5.44974 5.35424 4.56792 5.01489 3.731 4.58247C3.74367 4.56904 3.75441 4.55561 3.76554 4.54409ZM3.21367 5.16197C4.13555 5.66146 5.11312 6.05051 6.12615 6.32098C5.62954 8.04777 5.36886 9.83382 5.3513 11.6305H0.749836C0.833451 9.26122 1.69987 6.98649 3.21367 5.16197ZM3.21367 18.8666C1.69997 17.042 0.833547 14.7673 0.749836 12.3981H5.3513C5.36886 14.1948 5.62949 15.9808 6.12615 17.7076C5.11317 17.9782 4.1356 18.3672 3.21367 18.8666ZM8.71778 22.3958C8.64026 22.3762 8.56005 22.3509 8.48022 22.3275C8.38313 22.2991 8.28565 22.2707 8.18971 22.2396C8.10873 22.2135 8.0289 22.1855 7.94908 22.1575C7.85467 22.1248 7.76026 22.0915 7.667 22.0558C7.58718 22.0255 7.50851 21.9936 7.42945 21.9614C7.33773 21.923 7.246 21.8846 7.15505 21.8462C7.07676 21.8117 6.99885 21.7761 6.92133 21.7395C6.83191 21.6973 6.74287 21.6543 6.65269 21.6098C6.57593 21.5714 6.49918 21.5331 6.42242 21.4912C6.33569 21.4448 6.24972 21.3972 6.16376 21.3481C6.087 21.3055 6.01408 21.2617 5.94001 21.2172C5.85558 21.1666 5.77269 21.1144 5.68979 21.061C5.61688 21.0146 5.54396 20.9674 5.47219 20.919C5.39045 20.8638 5.30947 20.8062 5.22926 20.7486C5.15903 20.6984 5.0888 20.6481 5.01972 20.5951C4.94028 20.5353 4.86237 20.4735 4.78485 20.4113C4.71692 20.3572 4.64938 20.3035 4.58299 20.2478C4.50623 20.1841 4.43216 20.1177 4.35771 20.0517C4.29247 19.9937 4.22684 19.9366 4.16313 19.8775C4.08983 19.8091 4.01884 19.7381 3.94745 19.6679C3.88567 19.6069 3.82273 19.5466 3.76209 19.4841C3.75096 19.4722 3.74021 19.4599 3.72908 19.4484C4.56596 19.0158 5.44777 18.6763 6.35871 18.436C6.83253 19.9468 7.6755 21.3157 8.81142 22.4188C8.78034 22.4108 8.74887 22.4042 8.71778 22.3958ZM11.1029 22.7297C9.46077 22.4963 8.02123 20.7824 7.11552 18.2514C8.42496 17.9582 9.76122 17.8009 11.1029 17.782V22.7297ZM11.1029 17.0145C9.67962 17.0332 8.26229 17.2023 6.87451 17.5188C6.39263 15.8538 6.13843 14.1312 6.11885 12.3981H11.1029V17.0145ZM11.1029 11.6305H6.11885C6.13838 9.89733 6.39258 8.17475 6.87451 6.50979C8.26229 6.82626 9.67967 6.99532 11.1029 7.01407V11.6305ZM11.1029 6.24652C9.76117 6.22781 8.42496 6.07051 7.11552 5.77716C8.02123 3.24617 9.46077 1.53222 11.1029 1.29889V6.24652ZM19.7598 5.16197C21.2735 6.98654 22.1399 9.26127 22.2236 11.6305H17.6221C17.6046 9.83382 17.344 8.04777 16.8473 6.32098C17.8603 6.05037 18.8378 5.66136 19.7598 5.16197ZM14.2526 1.63239C14.3332 1.65235 14.4134 1.67768 14.4932 1.70109C14.5903 1.72949 14.6878 1.75788 14.7837 1.78897C14.8647 1.81507 14.9445 1.84308 15.0244 1.8711C15.1188 1.90372 15.2132 1.93711 15.3064 1.9728C15.3863 2.00312 15.4649 2.03497 15.544 2.06721C15.6357 2.10559 15.7274 2.14396 15.8184 2.18234C15.8967 2.21688 15.9746 2.25243 16.0521 2.28903C16.1415 2.33125 16.2306 2.37423 16.3208 2.41875C16.3975 2.45712 16.4743 2.4955 16.551 2.53733C16.6378 2.58377 16.7237 2.63136 16.8097 2.68048C16.8864 2.72308 16.9594 2.76683 17.0334 2.81135C17.1179 2.86201 17.2008 2.9142 17.2837 2.96755C17.3566 3.01398 17.4295 3.06119 17.5013 3.10954C17.583 3.16481 17.6636 3.22199 17.7438 3.27955C17.8144 3.32983 17.8846 3.38049 17.9541 3.43306C18.0332 3.49255 18.1107 3.55434 18.1886 3.61651C18.2561 3.67024 18.3241 3.72397 18.3905 3.78C18.4672 3.8437 18.5413 3.9101 18.6157 3.97611C18.681 4.03406 18.7466 4.09124 18.8103 4.15034C18.8836 4.21865 18.9546 4.28965 19.026 4.35988C19.0878 4.4209 19.1507 4.48116 19.2114 4.54371C19.2225 4.55561 19.2332 4.56789 19.2444 4.5794C18.4075 5.01201 17.5257 5.35151 16.6147 5.5918C16.14 4.08078 15.2959 2.712 14.159 1.60936C14.19 1.61742 14.2215 1.62395 14.2526 1.63239ZM11.8705 1.29889C13.5127 1.53222 14.9522 3.24617 15.8579 5.77716C14.5485 6.07037 13.2122 6.22767 11.8705 6.24652V1.29889ZM11.8705 7.01407C13.2938 6.99536 14.7112 6.82631 16.0989 6.50979C16.5808 8.17475 16.835 9.89733 16.8546 11.6305H11.8705V7.01407ZM11.8705 12.3981H16.8546C16.8351 14.1312 16.5809 15.8538 16.0989 17.5188C14.7112 17.2023 13.2938 17.0333 11.8705 17.0145V12.3981ZM11.8705 22.7297V17.782C13.2123 17.8008 14.5485 17.9581 15.8579 18.2514C14.9522 20.7824 13.5127 22.4963 11.8705 22.7297ZM19.2079 19.4845C19.1473 19.547 19.0847 19.6073 19.0229 19.6683C18.9515 19.7385 18.8802 19.8095 18.8069 19.8778C18.7431 19.9373 18.6775 19.993 18.6123 20.0525C18.5378 20.1185 18.4638 20.1845 18.3878 20.2482C18.3206 20.3042 18.2523 20.3583 18.184 20.4128C18.1072 20.4742 18.0305 20.5356 17.9514 20.5947C17.8816 20.6473 17.8106 20.6984 17.7392 20.7482C17.6597 20.805 17.5799 20.8634 17.4989 20.9163C17.4264 20.9655 17.3531 21.0131 17.2794 21.0599C17.1973 21.1128 17.1146 21.164 17.0311 21.2134C16.9544 21.2583 16.8811 21.302 16.8055 21.3454C16.7205 21.3938 16.6351 21.441 16.5491 21.487C16.4724 21.5279 16.3956 21.568 16.3188 21.6071C16.2313 21.6513 16.1431 21.6939 16.0544 21.7357C15.9777 21.7722 15.8978 21.8086 15.8188 21.8432C15.7286 21.8815 15.6373 21.9199 15.5459 21.9583C15.4665 21.9905 15.3874 22.0228 15.3076 22.0531C15.214 22.0888 15.1199 22.1222 15.0255 22.1548C14.9457 22.1828 14.8659 22.2108 14.7849 22.2369C14.6889 22.268 14.593 22.2964 14.4951 22.3244C14.4149 22.3482 14.3343 22.372 14.2534 22.3939C14.2223 22.4019 14.1912 22.4085 14.1601 22.4165C15.2961 21.3135 16.1391 19.9446 16.6128 18.4337C17.5237 18.6739 18.4055 19.0133 19.2424 19.4457C19.2298 19.4595 19.219 19.473 19.2079 19.4845ZM19.7598 18.8666C18.8379 18.3671 17.8603 17.9781 16.8473 17.7076C17.3439 15.9808 17.6046 14.1948 17.6221 12.3981H22.2236C22.14 14.7673 21.2736 17.0421 19.7598 18.8666Z",
    fill: "#121212"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(0 0.5)"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "location",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi bi-geo-alt",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "mail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi bi-envelope",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "phone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi bi-telephone",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.a0dd8a6ce095234791f2f43f5178825c.svg";
export { ForwardRef as ReactComponent };